import { isInternalAnalyticsEnabled } from './internalAnalytics';

const DEFAULT_GA_ID = 'G-GQJKWKPV83';

function getGaId() {
  return process.env.REACT_APP_GA_ID || DEFAULT_GA_ID;
}

function isEnabled() {
  return process.env.REACT_APP_ENABLE_ANALYTICS === '1';
}

function isDebug() {
  return process.env.REACT_APP_GA_DEBUG === '1';
}

function ensureGtagLoaded(gaId) {
  try {
    if (!gaId) return false;
    if (typeof window === 'undefined') return false;

    // Always ensure the stub exists; safe even if the script never loads.
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };

    // Ensure script is present (don't rely on existence of window.gtag).
    const existing = document.querySelector('script[data-skinny-ga="1"]');
    if (!existing) {
      const s = document.createElement('script');
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(gaId)}`;
      s.setAttribute('data-skinny-ga', '1');
      document.head.appendChild(s);
    }

    // Idempotent init/config.
    window.gtag('js', new Date());
    window.gtag('config', gaId, { send_page_view: false, debug_mode: isDebug() });
    return true;
  } catch (_) {
    return false;
  }
}

export function trackGaEvent(eventName, params = {}) {
  try {
    if (!isEnabled()) return false;
    if (isInternalAnalyticsEnabled()) return false;
    const gaId = getGaId();
    if (!ensureGtagLoaded(gaId)) return false;
    if (typeof window.gtag !== 'function') return false;
    window.gtag('event', eventName, params);
    return true;
  } catch (e) {
    if (isDebug()) {
      // eslint-disable-next-line no-console
      console.log('[GA] track error', e);
    }
    return false;
  }
}

